(function() {
  "use strict";

  var app = angular.module("fullyManagedApp", []);


  app.filter("rawHtml", [
        "$sce", "$compile", function ($sce, $compile) {
          return function (val) {
            val = val || "";
            return $sce.trustAsHtml(val);
          };
        }
  ]);

  app.directive("ngEnter", function () {
    return function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
        if (event.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.ngEnter);
          });

          event.preventDefault();
        }
      });
    };
  });

  app.directive("dotdotdot", function () {
    return function (scope, element, attrs) {
      setTimeout(function () {
        //jquery code and plugins
        $(element).dotdotdot();
      }, 0);

    };
  });

})();


// WEBPACK FOOTER //
// ./cmsscripts/custom/fully-managed.js